module.exports = __webpack_public_path__ + "static/communication-2-ee6b4a3210e44c0992245c1c1300279c.svg";